"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _reactRouterDom = require("react-router-dom");
var _resize = _interopRequireDefault(require("../../hocs/resize"));
var _ActivityPageComponent = _interopRequireDefault(require("./ActivityPageComponent"));
var _positionActions = require("../../redux/actions/positionActions");
require("./ActivityPage.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var product = state.product,
    productManifest = state.productManifest,
    router = state.router;
  var location = ownProps.location.pathname.lastIndexOf('/');
  location = ownProps.location.pathname.substr(location + 1);
  return {
    products: state.apexCore.product.products,
    product: product,
    productManifest: productManifest,
    component: ownProps.children,
    formObj: state.form.activityPage || {
      values: {
        product: 1
      }
    },
    initialValues: {
      product: state.apexCore.position.selectedProductId,
      component: location
    }
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    selectPositionAndSave: function selectPositionAndSave(productId) {
      return dispatch((0, _positionActions.selectPositionAndSave)(productId));
    },
    clearFilter: function clearFilter(productId) {
      dispatch((0, _reduxForm.change)('activityPage', 'product', productId));
      dispatch((0, _positionActions.selectPositionAndSave)(productId));
      dispatch((0, _reduxForm.change)('activityPage', 'startDate', null));
      dispatch((0, _reduxForm.change)('activityPage', 'endDate', null));
    }
  };
};
var container = (0, _reduxForm.reduxForm)({
  form: 'activityPage',
  destroyOnUnmount: false,
  onSubmit: function onSubmit() {}
})(_ActivityPageComponent["default"]);
var _default = exports["default"] = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _resize["default"])(container)));